// @ts-check
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { FleetPermissionsComponent } from './fleet-permissions-component';
import { AdminPermissionsComponent } from './admin-permissions-component';
import { ScopesPermissionsComponent } from './scopes-permissions-component';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ScopesReportsContainer from './scopes-reports-container/scopes-reprots-container';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  heading: {
    margin: theme.spacing(2)
  }
}));

export function GeneralPermissionsComponent({ user }) {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
        <small>
          <b>Permissions</b>
        </small>
      </Typography>

      <AdminPermissionsComponent user={user} />
      <FleetPermissionsComponent user={user} />
      <ScopesReportsContainer user={user} />
    </div>
  );
}
